module.exports = __webpack_public_path__ + "static/media/chair.7add2104.png";